/**
 * Brand lockup — the bloudraad X-mark (two strands twisted into a pliers
 * silhouette, from branding/icons/silhouette.svg) paired with the
 * Outfit-800 wordmark. silhouette.svg self-themes via prefers-color-scheme
 * inside the SVG, so the fill colour adapts in <img> contexts where
 * outside CSS doesn't propagate.
 */
export function Lockup({ className }: { className?: string }) {
  return (
    <div className={`flex flex-col items-center gap-5 ${className ?? ''}`}>
      <img src="/silhouette.svg" alt="bloudraad" width="200" height="200" />
      <span className="font-display text-4xl font-extrabold leading-none tracking-tight">bloudraad</span>
    </div>
  );
}
